import { CropStage } from "@/types/cropConfiguration";

export const SENSITIVITY_MAP = {
    low: {
        sufficiency_threshold: 0.94,
        deficiency_threshold: 0.9,
    },
    moderate: {
        sufficiency_threshold: 0.96,
        deficiency_threshold: 0.925,
    },
    high: {
        sufficiency_threshold: 0.97,
        deficiency_threshold: 0.925,
    },
};
export function calculateYBands(sensitivity: "low" | "moderate" | "high") {
    const thresholds = SENSITIVITY_MAP[sensitivity];
    return [
        { y0: 100, y1: 1000, color: "#ccccff", mapColor: "blue" },
        {
            y0: thresholds.sufficiency_threshold * 100,
            y1: 100,
            color: "#ccffcc",
            mapColor: "#66cc66",
        },
        {
            y0: thresholds.deficiency_threshold * 100,
            y1: thresholds.sufficiency_threshold * 100,
            color: "#ffffcc",
            mapColor: "yellow",
        },
        {
            y0: 0,
            y1: thresholds.deficiency_threshold * 100,
            color: "#ffcccc",
            mapColor: "red",
        },
        {
            y0: -1000,
            y1: 0,
            color: "#fff",
            mapColor: "gray",
        },
    ];
}

export function getYBandsFromCropStage(cropStage?: CropStage) {
    if (!cropStage) return calculateYBands("moderate");
    return [
        { y0: 100, y1: 1000, color: "#ccccff", mapColor: "blue" },
        {
            y0: cropStage.si_sufficient * 100,
            y1: 100,
            color: "#ccffcc",
            mapColor: "#66cc66",
        },
        {
            y0: cropStage.si_deficient * 100,
            y1: cropStage.si_sufficient * 100,
            color: "#ffffcc",
            mapColor: "yellow",
        },
        {
            y0: 0,
            y1: cropStage.si_deficient * 100,
            color: "#ffcccc",
            mapColor: "red",
        },
        {
            y0: -1000,
            y1: 0,
            color: "#fff",
            mapColor: "gray",
        },
    ];
}
